/** The plan a settings page needs, right-aligned on its sidebar row. */
export const SettingsPlanTag = ({ label }: { label: string }) => (
  <span className="inline-flex h-[17px] shrink-0 items-center rounded bg-[#0C41BB]/12 px-1.5 text-[10.5px] font-medium text-[#0C41BB]">
    {label}
  </span>
);
